"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _types = require("./types");
var _actionUtils = require("../../utils/actionUtils");
/** Set Scene layout action */
function setSceneLayout(sceneLayout) {
  return (0, _actionUtils.actionCreator)(_types.BROADCAST_SET_SCENE_LAYOUT, sceneLayout);
}
var _default = exports["default"] = setSceneLayout;